import React from "react"

type Props = {
  title: string
  backgroundImg?: string
}
const PageBanner = ({
  title,
  backgroundImg = "https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100",
}: Props) => {
  return (
    <div className="relative bg-branding md:min-h-[400px]">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src={backgroundImg}
          alt=""
        />
        <div
          className="absolute inset-0 bg-branding mix-blend-multiply"
          aria-hidden="true"
        />
      </div>
      <div className="relative max-w-7xl mx-auto py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
          {title}
        </h1>
      </div>
    </div>
  )
}

export default PageBanner
